import React from 'react';
import Soon from '../Soon';

function Header() {
  return (
    <div>
      <Soon />
    </div>
  );
}

export default Header;
